export const isSearchEngineMode = (): boolean => {
  const location = window.location

  const isYandexOrGoogle = location.hostname.includes('webcache')
  const isMail = location.pathname.includes('mcached')
  const isBing = location.pathname.includes('cache.aspx')

  return isYandexOrGoogle || isMail || isBing
}
